import React, { useState, useEffect } from 'react';
import { Card, Table, Button, Tooltip, Typography,message } from 'antd';
import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import { usePagination } from '../context/PaginationProvider';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from '../util/axiosConfig';
import '../styles/userlist.css';

const { Text } = Typography;
// interface PanelProps {
//     inputData: any; // You can replace 'any' with a more specific type if needed
//   }
const AuditLog: React.FC = () => {
    const { pagination, setTotal, setPage, setPageSize } = usePagination();
    const [panelData, setPanelData] = useState<any>(null);
    const { page, pageSize, sort_by, sort_order } = pagination;
    const [users, setUsers] = useState<any>([]);
    const navigate = useNavigate();
    const [, setLoading] = useState(false);
    const location = useLocation();
    const [paginationConfig, setPaginationConfig] = useState({
        current: page,
        pageSize: pageSize,
        total: 0,
        showTotal: (total: number, range: [number, number]) => `Showing ${range[0]}-${range[1]} of ${total} entries`,
        showSizeChanger: true,
        pageSizeOptions: ["5", "10", "20", "50"],
        locale: { items_per_page: "" },
        onChange: (page: number, pageSize: number) => {
            setPage(page);
            setPageSize(pageSize);
            setPaginationConfig((prev: any) => ({
                ...prev,
                current: page,
                pageSize: pageSize,
            }));
        },
        onShowSizeChange: (current: number, size: number) => {
            setPage(current);
            setPageSize(size);
            setPaginationConfig((prev: any) => ({
                ...prev,
                current: current,
                pageSize: size,
            }));
        },
    });
    useEffect(() => {
            fetchUserList();
        }, [page, pageSize, sort_by, sort_order]);

    const fetchUserList = async () => {
        const urlParams = new URLSearchParams(window.location.search);
        const data = Object.fromEntries(urlParams.entries());
        setPanelData(data);        
        setLoading(true);
        try {
            const response = await axios.post('/api/v1/audit/get-pageable-audit-logs', {}, {
                params: {
                    pageSize: pageSize,
                    pageNo: page - 1,
                    sortByField: sort_by,
                    sortDirection: 'desc',
                    invoiceId: data.id
                },
            });
            if (Array.isArray(response?.data?.data?.content)) {
                setUsers(response?.data?.data?.content);
                setTotal(response.data?.data?.totalElements || 0);
                setPaginationConfig((prev) => ({
                    ...prev,
                    total: response.data?.data?.totalElements || 0,
                }));
            } else {
                console.error('Unexpected response format:', response.data);
            }
        } catch (error) {
            console.error('Failed to fetch panel data', error);
        } finally {
            setLoading(false);
        }
    };
    const exportAuditLog = async () => {
        setLoading(true);
    const url = '/api/v1/audit/get-pageable-audit-logs-export'; // Replace with your API URL
const headers = {
  'Authorization': 'Bearer YOUR_TOKEN', // Replace with your actual token or other headers
  'Content-Type': 'application/json' // Adjust as necessary
};
    try{
    const response = await axios.post(url, {}, {
        params: {
            pageSize: pageSize,
            pageNo: page - 1,
            sortByField: sort_by,
            sortDirection: 'desc',
            invoiceId: panelData.id
        },
        headers: headers,
        responseType: 'blob' // Set the response type to 'blob'
      });
  
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadUrl;
      let currentdate = new Date();
      var Today = currentdate.getDate() + "/"
        + (currentdate.getMonth() + 1) + "/"
        + currentdate.getFullYear() + "@ "
        + currentdate.getHours() + ":"
        + currentdate.getMinutes() + ":"
      const fileName = `${panelData.invoiceReference}_${Today}.xlsx`;
      a.download = fileName; 
      document.body.appendChild(a);
      a.click();
      a.remove();
      message.success('Exported successfully!')
      window.URL.revokeObjectURL(downloadUrl);
        } catch (error) {
            console.error('Failed to export invoice:', error);
        }finally {
            setLoading(false);
        }
    };
    

    const handleEdit = (id: any, record: any) => {
        navigate(`/user-list/edit/${id}`);
    };

    const handleAdd = () => {
        navigate(`/user-list/add`);
    };

    const columns: any = [
        {
            title: 'Log No',
            dataIndex: 'logNo',
            key: 'logNo',
        },
        {
            title: 'Modified Field',
            dataIndex: 'modifiedField',
            key: 'modifiedField',
        },
        {
            title: 'Previous Value',
            dataIndex: 'previousValue',
            key: 'previousValue',
        },
        {
            title: 'Modified Value',
            dataIndex: 'modifiedValue',
            key: 'modifiedValue',
        },
        {
            title: 'Previous User',
            dataIndex: 'previousUser',
            key: 'previousUser',
        },
        {
            title: 'Modified User',
            dataIndex: 'modifiedUser',
            key: 'modifiedUser',
        },
        {
            title: 'Modified On',
            dataIndex: 'modifiedOn',
            key: 'modifiedOn',
            render: (modifiedOn: any) => (
                <span >
                    {modifiedOn.split('T')[0]}
                </span>
            ),
        },
    ];


    return (
        <>
        <div className='exportBtn'>
        <Button onClick={() => exportAuditLog()}>Export</Button>
        </div>
            <Card>
                <Table
                    className='userTable'
                    dataSource={users}
                    size='small'
                    columns={columns}
                    bordered={false}
                    pagination={paginationConfig}
                />
            </Card>
        </>
    );
};

export default AuditLog;
